module.exports = __webpack_public_path__ + "img/star-full.9f7984c.png";